import $ from 'jquery';
import SubscribeService from '../service/SubscribeService';
import Popup from '../utilities/Popup';

$('body').on('submit', '.footer-form', (e) => {
    e.preventDefault();
    SubscribeService.subscribeByEmail(
        $('.footer-form__email').val(),
        // [1,2,3]
    ).then((response) => {
        const message = response.status === 'success'
            ? 'Спасибо за Вашу подписку! <br/>Письмо с подтверждением отправлено на Ваш e-mail адрес'
            : 'Не удалось подписать e-mail, возможно он уже используется';
        Popup.notify(message);
    });
});
